const DpoXrn = {
    fields: [
        "ulice",
        "orientacnicislo",
        "domovnicislo",
        "obec",
        "castobce",
        "mestskacast",
        "psc",
        "posta",
        "okres",
    ],

    init: function() {
        const tlacitkoXrn = $("#modal-button-vyhledej-adresu");
        const kod = $("#modal-kodadresy");
        if (!tlacitkoXrn.length) {
            return;
        }

        const tlacitkoUlozit = $("#dialogButtons").find("button.btn.btn-primary");
        if ('' === kod.val()) {
            tlacitkoUlozit.attr("disabled", true).prop("disabled", true);
        }

        tlacitkoXrn
            .off("click")
            .on("click", function(e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }
                DpoXrn.vyhledejAdresu();
            });
    },

    doplnAdresu: function (kodadresy) {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/xrn/doplnAdresu";

        const section = $('#idSection');
        if (section.length && section.val()) {
            url += '/' + section.val();
        }

        const item = $('#idItem');
        if (item.length && item.val()) {
            url += '/' + item.val();
        }

        let postData = {kodadresy: kodadresy};
        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: false,
            complete: function() {
                DynaCore_Item.miniformReload(102, 1);
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r.status) {

                }
            }
        });
    },

    vyhledejAdresu: function() {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/xrn/vyhledejAdresu";

        const section = $('#idSection');
        if (section.length && section.val()) {
            url += '/' + section.val();
        }
        const item = $('#idItem');
        if (item.length && item.val()) {
            url += '/' + item.val();
        }

        const modal = $("[id^=\"modal-container-\"]").last();

        let postData = {};
        $.each($(modal).find("form").serializeArray(), function(_, kv) {
            postData[kv.name] = kv.value;
        });

        const _ch = $("#_ch");
        if (_ch.length) {
            postData["_ch"] = _ch.val();
        }

        $.ajax({
            type: "post",
            url: url,
            data: postData,
            dataType: "json",
            global: false,
            beforeSend: function() {
                Lemo_Alert.closeAll();
                Lemo_Alert.addInfo("Vyhledávám adresu ...", "addressSearchBeforeSend");
            },
            complete: function() {
                Lemo_Alert.closeById("addressSearchBeforeSend");
            },
            success: function(r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true === r.status) {
                    if (r.hasOwnProperty("data")) {
                        DpoXrn.aktualizujFormular(r['data']);
                    }

                    $("#dialogButtons").find("button.btn.btn-primary").attr("disabled", false).prop("disabled", false);
                    Lemo_Alert.addSuccess("Adresa byla úspěšně vyhledána.", "addressLoadSuccess");
                }
            },
            error: function() {
                Lemo_Alert.addDanger("Vyhledání adresy selhalo.", "addressSearchError");
            }
        });
    },

    aktualizujFormular: function(data) {
        if (data.hasOwnProperty("kodadresy")) {
            $("#modal-kodadresy").val(data["kodadresy"]);
        }

        $.each(DpoXrn.fields, function(i, field) {
            let element = $("#modal-" + field);
            if (element.length) {
                element.val(data[field]);
            }
        });
    },

    vymazKod: function() {
        const kod = $("#modal-kodadresy");
        kod.val('');
        const tlacitkoUlozit = $("#dialogButtons").find("button.btn.btn-primary");
        tlacitkoUlozit.attr("disabled", true).prop("disabled", true);
    },
};

$(document).ready(function() {
    $(document)
        .on("modal.miniform.item.add.build modal.miniform.item.add.error", function() {
            DpoXrn.init();
        })
        .on("modal.miniform.item.edit.build modal.miniform.item.add.error", function() {
            DpoXrn.init();
        });
});